export default "__VITE_ASSET__37a79bf6__"